export const outdatedFurnitureTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if ((desyncdata.indexOf('KeyError: \'get_joint_transform_from_rig') !== -1 && desyncdata.indexOf('Unable to find joint') !== -1) || desyncdata.indexOf('Could not slot') !== -1 || desyncdata.indexOf('ValueError: Unable to find rig for joint') !== -1) {
			return {
				type: 'outdatedFurnitureTest',
				color: 'IndianRed',
				title: 'Outdated Furniture Error',
				text: 'Outdated Custom Content furniture requires fixing.',
				description: 'Outdated Custom Content furniture will cause errors on load or when placing objects.<br/><br/>' +
				'You can either remove the installed furniture mod(s) or fix the installed furniture mod(s) by using <a href="http://sims4studio.com/thread/1523/downloading-sims-4-studio/" target="_blank" rel="noopener noreferrer">Sims4Studio</a> Batch Fixes.<br/><br/>' +
				'Batch Fixes are located at the top of the application:<br/><strong>Content Management -> Batch Fixes -> Objects</strong><br/>The most common ones to help are:' +
				'<br/>- \'Fix Objects for Cats & Dogs Patch\'<br/>- \'Fix Dining Tables & Chairs for Dine Out & Parenthood Game Packs\''
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>6f83007ca4d17f6a5b3d02fe</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4.15.mac</sku>
        <createtime>2099-07-04 10:40:57</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.83.1220-1.200.000.350.Release</buildsignature>
        <categoryid>part.py:149</categoryid>
        <desyncid>6f83007ca4d17f6a5b3d02fe</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception in &lt;function c_api_set_object_location_ex at 0x18428f710&gt;, args: (16333335790236859, 1105923683475785141, {3A071515C634BB,0,World}, Transform(Vector3(409.847931, 193.831909, 429.446259), Quaternion(0.000000, -0.500000, 0.000000, 0.866025)), 0, (0, 0), 0), kwargs: {}
KeyError('Unable to find joint b__subroot__2 on object_sitLoveseatQA2x1_01:0x0f5907bb0e4405b5[2]',) (KeyError: 'Unable to find joint b__subroot__2 on object_sitLoveseatQA2x1_01:0x0f5907bb0e4405b5[2]')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 183, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\part.py&quot;, line 147, in get_joint_transform
  File &quot;T:\InGame\Gameplay\Scripts\Core\native\animation\__init__.py&quot;, line 239, in get_joint_transform_from_rig
KeyError: 'get_joint_transform_from_rig: Joint name [b__subroot__2] was not found in the specified rig [d3bd443591923403.8eaf13de]. JointNameHash [0x0]().'

During handling of the above exception, another exception occurred:

Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\build_buy.py&quot;, line 834, in c_api_set_object_location_ex
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 1502, in set_parent
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 348, in location
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 405, in set_location_without_distribution
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\part.py&quot;, line 575, in on_owner_location_changed
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\part.py&quot;, line 149, in get_joint_transform
KeyError: 'Unable to find joint b__subroot__2 on object_sitLoveseatQA2x1_01:0x0f5907bb0e4405b5[2]'
</desyncdata>
    </report>
</root>
*/

/*
<root>
    <report>
        <version>2</version>
        <sessionid>80c1ed2d2bc668fe5bb14ecd</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-10-01 01:33:31</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>part.py:151</categoryid>
        <desyncid>80c1ed2d2bc668fe5bb14ecd</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception in &lt;function c_api_set_object_location_ex at 0x000007FFD77EF9E0&gt;, args: (316943714791922430, 626853791878152344, {46602A11DF71AFE,0,World}, Transform(Vector3(216.768890, 155.968201, 171.620575), Quaternion(0.000000, 0.000000, 0.000000, 1.000000)), 0, (0, 0), 0), kwargs: {}
ValueError(&quot;Unable to find rig for joint '00000000!ee02701b'6fc2a9dc.8eaf13de' on object_bedSingleFC_01:0x08b30833d7010098[0]&quot;,) (ValueError: Unable to find rig for joint '00000000!ee02701b'6fc2a9dc.8eaf13de' on object_bedSingleFC_01:0x08b30833d7010098[0])
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 183, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\part.py&quot;, line 147, in get_joint_transform
  File &quot;T:\InGame\Gameplay\Scripts\Core\native\animation\__init__.py&quot;, line 239, in get_joint_transform_from_rig
ValueError: Failed to load rig resource using provided key (0x00000000, 0xee02701b6fc2a9dc, 0x8eaf13de)

During handling of the above exception, another exception occurred:

Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\build_buy.py&quot;, line 834, in c_api_set_object_location_ex
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 1502, in set_parent
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 348, in location
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 405, in set_location_without_distribution
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\part.py&quot;, line 575, in on_owner_location_changed
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\part.py&quot;, line 151, in get_joint_transform
ValueError: Unable to find rig for joint '00000000!ee02701b'6fc2a9dc.8eaf13de' on object_bedSingleFC_01:0x08b30833d7010098[0]
</desyncdata>
    </report>
*/


// WEBPACK FOOTER //
// ./src/tests/mods/outdatedFurnitureTest.js